module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters-categories"
  }, [(_vm.filters.length > 0) ? _c('div', {
    staticClass: "filters d-flex justify-center"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.filters), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "filters-wrapper",
      style: (("width: " + _vm.width + "%"))
    }, [_c('div', {
      class: [
        'wrapper-item',
        {
          'active-filter': item.active
        } ],
      on: {
        "click": function($event) {
          _vm.filterOnClick(item, index)
        }
      }
    }, [_c('img', {
      staticClass: "filters-img",
      attrs: {
        "src": item.urlImage,
        "alt": item.title
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "filters-text"
    }, [_vm._v(_vm._s(item.title))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "wrapper-buttons-filters"
  }, [_c('div', {
    staticClass: "swiper-button-prev item-btn btn-left",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/filters/arrow-left.svg",
      "alt": "flecha izquierda"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next item-btn btn-right",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/filters/arrow-right.svg",
      "alt": "flecha derecha"
    }
  })])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00cc85a4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Filters.vue
// module id = 1061
// module chunks = 40